const Achievement = [
    {
        "id":1,
        "course":"Complete web development with Programming-Hero",
        "by":"Programming-Hero",
        "img":"https://i.postimg.cc/Twc4hfBd/131912886-10157644490656891-138179017108349266-o.jpg",
    },
    {
        "id":2,
        "course":"Front End Web Development For Beginners (A Practical Guide)",
        "by":"udemy",
        "img":"https://udemy-certificate.s3.amazonaws.com/image/UC-830fc506-dd6e-468c-8aec-5f29a9f6b887.jpg",
    },
    
    {
        "id":3,
        "course":"Web Development And Javascript Bootcamp",
        "by":"Udemy",
        "img":"https://udemy-certificate.s3.amazonaws.com/image/UC-61594a75-9bf5-4cfb-99e1-27fd66749927.jpg",
    },
];
export default Achievement;